import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage, injectIntl } from 'react-intl'
import { FilterTable } from 'gnos-tables'
import _ from 'lodash'

import Entity from '../../../../../../../../../../../components/TableCell/components/Entity'
import Signals from '../../../../../../../../../../../components/TableCell/components/Signals'
import CustomDate from '../../../../../../../../../../../components/CustomDate'

import hocConnect from './hocConnect'
import { LOCALE_PREFIX } from '../../constants'
import './style.scss'
import CellStyleWrapper from '../../../../../../../../../../../components/TableCell/components/CellStyleWrapper'

@hocConnect
@injectIntl
export default class FirmsOnAddress extends Component {
    static propTypes = {
        activeTab: PropTypes.func.isRequired,
        addressesFirmsOnAddressTableChange: PropTypes.func.isRequired,
        block: PropTypes.string.isRequired,
        customData: PropTypes.object,
        data: PropTypes.shape({
            address: PropTypes.object,
            summary: PropTypes.object,
            table: PropTypes.object,
        }),
        id: PropTypes.string.isRequired,
        intl: PropTypes.object,
        level: PropTypes.string.isRequired,
        module: PropTypes.string.isRequired,
        ruianId: PropTypes.number,
    }

    shouldComponentUpdate(nextProps) {
        if (this.props.level !== nextProps.level) return true
        if (this.props.id !== nextProps.id) return true
        if (this.props.block !== nextProps.block) return true
        if (this.props.ruianId !== nextProps.ruianId) return true
        if (!_.isEqual(this.props.data, nextProps.data)) return true
        if (!_.isEqual(this.props.customData, nextProps.customData)) return true

        return false
    }

    handleChooseAddressClick = () => {
        const { id, activeTab } = this.props

        activeTab(`addresses-tabs-${id}`, 0)
    }

    handleTableChange = (changeData) => {
        const { module, block, id, customData, level, ruianId, addressesFirmsOnAddressTableChange } = this.props

        addressesFirmsOnAddressTableChange(module, block, id, level, customData, ruianId, changeData)
    }

    render() {
        const { id, data, intl } = this.props

        const actAddress = _.get(data, 'address.value', null)
        const tableData = _.get(data, 'table', {})

        return (
            <div className={'firms-on-address-container'}>
                <div className={'info-container'}>
                    <div>
                        <FormattedMessage
                            id={`${LOCALE_PREFIX}.onThisAddress`}
                            values={{ address: actAddress, strong: (chunks) => <strong>{chunks}</strong> }}
                        />
                    </div>
                    <div>
                        <span>
                            <FormattedMessage id={`${LOCALE_PREFIX}.chooseAddress`} />
                            <button onClick={this.handleChooseAddressClick} className={'text-button'}>
                                <FormattedMessage id={`${LOCALE_PREFIX}.addresses`} />
                            </button>
                        </span>
                    </div>
                </div>
                <div className={'table-container'}>
                    {!_.isEmpty(_.get(tableData, 'data', [])) && (
                        <FilterTable
                            id={`firms-on-address-filter-table-${id}`}
                            columnsDefinition={[
                                {
                                    Header: intl.formatMessage({ id: `${LOCALE_PREFIX}.name` }),
                                    accessor: 'subject',
                                    Cell: (value) => (
                                        <Entity
                                            entity={_.get(value, 'value', null)}
                                            type={_.get(value, 'value.type', null)}
                                            value={_.get(value, 'value.name', null)}
                                            entId={_.get(value, 'value.id', null)}
                                            inactive={_.get(value, 'value.inactive')}
                                            rowInactive={_.get(value, 'original.inactive')}
                                        />
                                    ),
                                },
                                {
                                    Header: intl.formatMessage({ id: `${LOCALE_PREFIX}.type` }),
                                    accessor: 'type',
                                    Cell: (type) => (
                                        <CellStyleWrapper isNotActive={type?.original?.inactive}>
                                            {type?.value}
                                        </CellStyleWrapper>
                                    ),
                                    width: 140,
                                },
                                {
                                    Header: intl.formatMessage({ id: `${LOCALE_PREFIX}.signals` }),
                                    accessor: 'subject.indicators',
                                    Cell: (value) => (
                                        <CellStyleWrapper isNotActive={value?.original?.inactive}>
                                            <Signals
                                                id={_.get(value, 'original.subject.id', null)}
                                                risk={_.get(value, 'value.risk', 0)}
                                                caution={_.get(value, 'value.caution', 0)}
                                                notice={_.get(value, 'value.notice', 0)}
                                            />
                                        </CellStyleWrapper>
                                    ),
                                },
                                {
                                    Header: intl.formatMessage({ id: `${LOCALE_PREFIX}.durationFrom` }),
                                    accessor: 'startDate',
                                    sortable: true,
                                    Cell: (value) => (
                                        <CellStyleWrapper isNotActive={value?.original?.inactive}>
                                            <CustomDate
                                                date={_.get(value, 'value.value', null)}
                                                precision={_.get(value, 'value.precision', null)}
                                            />
                                        </CellStyleWrapper>
                                    ),
                                    width: 105,
                                },
                                {
                                    Header: intl.formatMessage({ id: `${LOCALE_PREFIX}.durationTo` }),
                                    accessor: 'endDate',
                                    sortable: true,
                                    Cell: (value) => (
                                        <CellStyleWrapper isNotActive={value?.original?.inactive}>
                                            <CustomDate
                                                date={_.get(value, 'value.value', null)}
                                                precision={_.get(value, 'value.precision', null)}
                                            />
                                        </CellStyleWrapper>
                                    ),
                                    width: 105,
                                },
                            ]}
                            data={_.get(tableData, 'data', [])}
                            onTableChange={this.handleTableChange}
                            settings={{
                                sorted: _.get(tableData, 'sorted', []),
                                pagination: _.get(tableData, 'pagination', {}),
                            }}
                            loading={_.get(tableData, 'isLoading', false)}
                            texts={{
                                pagination: {
                                    page: intl.formatMessage({ id: 'global.page' }),
                                    from: intl.formatMessage({ id: 'global.of' }),
                                    rowCount: intl.formatMessage({ id: 'global.rowCount' }),
                                    rowShow: intl.formatMessage({ id: 'global.rowShow' }),
                                    all: intl.formatMessage({ id: 'global.all' }),
                                },
                            }}
                        />
                    )}
                </div>
            </div>
        )
    }
}
